import React from 'react';
import {connect} from 'react-redux'
import {Link} from 'react-router-dom'
import {  FaReact, FaBell, FaCoins, FaFileAlt,
  FaCheck, FaUserShield,
  FaTimesCircle, FaStore, FaExclamation,
  FaChartBar, FaClipboardCheck,
  FaBoxes,
  FaUserCheck, FaTasks } from 'react-icons/fa';
import {APP_VERSION} from '../constants'
import {getToken, setLocalKeyValue, getLocalKeyValue, getDateRange,
  getUserSettings} from '../storage'
import moment from 'moment'
function Panel(props) {


  return (

          <Link to={props.link} className="">
            <div className="sbottom dashboard-link">
              <div className="text-center">
                <div style={{fontSize:60}}>{props.children}</div>
                <div style={{fontSize:18, color:'#464747'}}>{props.title}</div>
              </div>
            </div>
          </Link>
  )
}



class Dashboard extends React.Component {
  constructor(props) {
    super(props)
    document.title = "Your Dashboard"
  }
  render() {
    let settings = getUserSettings()
    let billNotification
    let clientsPanel= <Panel title="CLIENTS" link="/clients" >
    <FaUserShield  style={{height:"0.8em"}} />
    </Panel>
    if(settings && settings.options && settings.options.enable_departments) {
      clientsPanel = <Panel title="COST CENTERS" link="/costcenters" >
      <FaBoxes  style={{height:"0.8em"}} />
      </Panel>
    }

    if(settings && settings.options){
      const lastDate = settings.options.deactivation_date
      const discontinued = settings.options.discontinued

      if(lastDate) {
        var expiryDate = new Date(lastDate)
        var currentDate = new Date()
        var diffInDays =  (expiryDate - currentDate) / (1000 * 60 * 60 * 24);
        // Show the notification only when the expiry is less than 30 days.
        if (diffInDays  < 45 ) {

          billNotification = <div style={{backgroundColor:'brown',padding:10, fontSize:18}} className="text-white text-center">
            Please renew your subscription by <u>{lastDate}</u>, ph:+91 9100433579 <FaExclamation />
          </div>
          if(discontinued){
            billNotification = <div style={{backgroundColor:'red',padding:20, fontSize:20}} className="text-white text-center">
            We regret to inform that we are discontinuing our services from <u>{lastDate}</u>
          </div>
          }
        }

      }
    }

    return (<div>

        <section className="small">
      {billNotification}
        </section>

        <div className="text-center">
          <Panel title="ITEMS" link="/items" >
            <FaStore style={{height:"0.8em"}} />
          </Panel>

          <Panel title="SALES" link="/invoices" >
              <FaFileAlt style={{height:"0.8em"}} />
          </Panel>


          <Panel title="PURCHASES" link="/purchases" >
            <FaClipboardCheck style={{height:"0.8em"}} />
          </Panel>

          <Panel title="SUPPLIERS" link="/suppliers" >
              <FaUserCheck  style={{height:"0.8em"}} />
          </Panel>

          {clientsPanel}

          <Panel title="DAY BOOK" link="/reports/day_book" >
              <FaTasks style={{height:"0.8em"}} />
          </Panel>

          <Panel title="GSTR REPORTS" link="/reports/gstr_reports" >
            <FaChartBar style={{height:"0.8em"}} />
            </Panel>
        </div>

        <section className="medium">

        </section>

    </div>)
  }
}
const mapStateToProps = (state) => {
  return {
    auth: state.authReducer
  }
}

export default connect(mapStateToProps)(Dashboard)



// WEBPACK FOOTER //
// ./src/components/dashboard.js